import { Autocomplete, TextField } from '@mui/material';
import { InventoryAsset } from '../../../types';
import { formatLocation, MOVE_REQUEST } from './serviceRequestModel';
import { InventoryFieldProps, inventoryLabel } from './inventoryField';

interface AssetSelectionFieldProps extends InventoryFieldProps {
  requestType: string;
  selected: InventoryAsset | null;
  onChange: (value: InventoryAsset | null) => void;
}

/** The existing service a Move or Change acts on; a Move also names its supplier and bandwidth or circuit. */
export function AssetSelectionField({
  disabled,
  options,
  displayLocationCode,
  requestType,
  selected,
  onChange
}: AssetSelectionFieldProps) {
  return (
    <div style={{ breakInside: 'avoid', marginBottom: '1.5rem' }}>
      <Autocomplete
        id="asset-selection"
        sx={{ width: '100%' }}
        size="small"
        options={options}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option: InventoryAsset) => {
          if (option === null) return '';
          const address = formatLocation(option, displayLocationCode);
          if (requestType === MOVE_REQUEST && option.supplier?.name) {
            const detail = option.bandwidth
              ? ` — ${option.bandwidth}`
              : option.circuitIDs
                ? ` (${option.circuitIDs})`
                : '';
            return `${option.supplier.name}, ${address}${detail}`;
          }
          return address;
        }}
        value={selected}
        onChange={(_, newValue) => onChange(newValue)}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label={inventoryLabel(displayLocationCode)}
            inputProps={{
              ...params.inputProps,
              required: selected === null
            }}
          />
        )}
      />
    </div>
  );
}
